"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoAnalytics = void 0;
var BitmovinAnalytics_1 = require("./BitmovinAnalytics");
var videoAnalytics = /** @class */ (function () {
    function videoAnalytics(analyticsConfig) {
        this.analyticsInstance = new BitmovinAnalytics_1.BitmovinAnalytics(analyticsConfig);
    }
    videoAnalytics.prototype.setup = function (videoAnalyticsConfig) {
        this.analyticsInstance.setup(videoAnalyticsConfig);
    };
    return videoAnalytics;
}());
exports.videoAnalytics = videoAnalytics;
